import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ExpandCustomIcon from 'assets/images/Zooming/expandCustom.svg';
import MinusCustomIcon from 'assets/images/Zooming/minusCustom.svg';
import PlusCustomIcon from 'assets/images/Zooming/plusCustom.svg';
import { useInterimsTimeRange } from './hooks/useInterimsTimeRange';
import { styled } from '@mui/material/styles';
import { GraphTooltip } from './components/GraphTooltip';
import { useTranslation } from 'react-i18next';

const ZoomingIconButton = styled(IconButton)(({ theme }) => ({
  width: theme.spacing(36),
  height: theme.spacing(22),
}));

export const InterimZoomSelect = () => {
  const { zoomIn, zoomOut, zoomExpand } = useInterimsTimeRange();
  const { t } = useTranslation();
  return (
    <Stack direction="row" alignItems="center" justifyContent="center" gap={8}>
      <Typography variant="text3" color="text.secondary">
        Zoom:
      </Typography>
      <GraphTooltip title={t('common.zoomIn')}>
        <ZoomingIconButton onClick={() => zoomIn(0.1)} aria-label="zoom in">
          <PlusCustomIcon width={16} height={16} />
        </ZoomingIconButton>
      </GraphTooltip>
      <GraphTooltip title={t('common.zoomOut')}>
        <ZoomingIconButton onClick={() => zoomOut(0.1)} aria-label="zoom out">
          <MinusCustomIcon width={16} height={16} />
        </ZoomingIconButton>
      </GraphTooltip>
      <GraphTooltip title={t('common.zoomOutMax')}>
        <ZoomingIconButton onClick={() => zoomExpand()} aria-label="max zoom out">
          <ExpandCustomIcon width={16} height={16} />
        </ZoomingIconButton>
      </GraphTooltip>
    </Stack>
  );
};
